'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'palette';
var width = 512;
var height = 512;
var aliases = [127912];
var unicode = 'f53f';
var svgPathData = ['M32 256c0 123.7 100.3 224 224 224 3.1 0 6.2-.1 9.3-.2 10.4-.4 22.7-10.7 22.7-30 0-5.3-1.9-11.8-6.9-23.5-.6-1.5-1.3-3.1-2.1-4.8-4.3-9.7-10.3-23.2-13.2-37-1.1-5.4-1.7-10.9-1.7-16.6 0-44.2 35.8-80 80-80l97.9 0c24.3 0 37.9-15.6 38.1-29.7 0-.8 0-1.6 0-2.3 0-123.7-100.3-224-224-224S32 132.3 32 256zm120 0a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm32-96a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96-32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm96 32a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M480 258.3c-.1 14.1-13.8 29.7-38.1 29.7L344 288c-44.2 0-80 35.8-80 80 0 5.6 .6 11.2 1.7 16.6 2.9 13.8 8.9 27.3 13.2 37 .8 1.7 1.5 3.3 2.1 4.8 5 11.6 6.9 18.2 6.9 23.5 0 19.2-12.3 29.6-22.7 30-3.1 .1-6.2 .2-9.3 .2-123.7 0-224-100.3-224-224S132.3 32 256 32 480 132.3 480 256c0 .8 0 1.6 0 2.3zm32 .3c0-.9 0-1.8 0-2.7 0-141.4-114.6-256-256-256S0 114.6 0 256 114.6 512 256 512c3.5 0 7.1-.1 10.6-.2 31.8-1.3 53.4-30.1 53.4-62 0-14.5-6.1-28.3-12.1-42-4.3-9.8-8.7-19.7-10.8-29.9-.7-3.2-1-6.5-1-9.9 0-26.5 21.5-48 48-48l97.9 0c36.5 0 69.7-24.8 70.1-61.3zM152 256a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPalette = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;